import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import type { Movie } from "@/mocks/movies";

interface HotMoviesProps {
  movies: Movie[];
}

const tabs = [
  { key: "movie", label: "热门电影" },
  { key: "tv", label: "热门剧集" },
];

export default function HotMovies({ movies }: HotMoviesProps) {
  const [active, setActive] = useState("movie");

  const list = useMemo(
    () =>
      movies
        .filter((m) => m.type === active)
        .sort((a, b) => b.popularity - a.popularity)
        .slice(0, 8),
    [movies, active]
  );

  return (
    <section className="mt-10">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">热门影片推荐</h2>
          <p className="mt-1 text-sm text-foreground-500">根据播放热度实时推荐，发现正在被追的好片</p>
        </div>
        <div className="flex items-center gap-1 rounded-full bg-background-200 p-1">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActive(tab.key)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                active === tab.key
                  ? "bg-primary-600 text-white"
                  : "text-foreground-600 hover:text-foreground-950"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {list.map((movie, i) => (
          <MovieCard key={movie.id} movie={movie} rank={i + 1} />
        ))}
      </div>

      <div className="mt-6 flex justify-center">
        <Link
          to={`/category/${active}`}
          className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
        >
          查看全部{active === "movie" ? "电影" : "剧集"} <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}